import { AnyAssetApplication, AssetParams } from '@mss/mss-component-library';
import { AllMonitorsAPI } from '../../../index';

export function findScopedMonitors(
  allMonitors: AllMonitorsAPI[],
  assetParams: Pick<Partial<AssetParams>, 'assetType' | 'assetSubType'>,
  asset?: AnyAssetApplication & { series: number }
) {
  return allMonitors.filter(x => {
    const { assetType, assetSubType } = assetParams;
    const [type, subtype] = x.category.split('.');
    const matchingType =
      type === assetType && (subtype ?? assetSubType) === assetSubType;
    if (x.supported_series && asset) {
      return matchingType && x.supported_series.includes(asset.series);
    }
    return matchingType;
  });
}
